"use client";

import { useEffect } from "react";

export interface UseInjectScriptProps {
  id: string;
  src: string;
  async?: boolean;
  defer?: boolean;
  enabled?: boolean;
}

export const useInjectScript = ({
  id,
  src,
  async = false,
  defer = false,
  enabled = true,
}: UseInjectScriptProps) => {
  useEffect(() => {
    if (!enabled) return;

    const script = document.createElement("script");
    script.src = src;
    script.id = id;
    script.async = async;
    script.defer = defer;
    document.body.appendChild(script);
    return () => {
      document.body.removeChild(script);
    };
  }, [src, id, async, defer, enabled]);

  return null;
};
